import { Capacitor } from "@capacitor/core";
import { isNativeNavigationAvailable } from "@eventr/native/navigation";

/**
 * Native navigation is enabled on iOS only. Android and web use a plain BrowserRouter,
 * the web NavBar, and web headers, with no use of the native navigation plugin. Every
 * native-navigation gate in the app reads from this single flag.
 */
export function isIosNativeNavigation(): boolean {
  return Capacitor.getPlatform() === "ios" && isNativeNavigationAvailable();
}
